export default __webpack_public_path__ + "static/media/Nergal's Bludgeon of Agonizing Wounds.16a8423d.jpg";